module.exports = __webpack_public_path__ + "assets/fonts/Montserrat-ExtraBold.9bc77c3b-ps.ttf";